import store from '@/store/index'
import Vue from 'vue'
import * as qiniu from 'qiniu-js'
import AMapLoader from "@amap/amap-jsapi-loader";

const qiniuUrl = 'https://zhunpin.net/'

export const mapKey = '7982d53ea52e1e06d5dc038f112b3be2'

export function setStorage(key,data){
	const serializedData = JSON.stringify(data);
	sessionStorage.setItem(key, serializedData);
}

export function getStorage(key){
	const serializedData = sessionStorage.getItem(key);
	return serializedData?JSON.parse(serializedData):null;
}

export function removeStorage(key){
	return sessionStorage.removeItem(key);
}

export function setErrLog(type,err){
	let errLogList = getStorage('errLogList')||[]
	errLogList.push({type:type,err:err})
	setStorage('errLogList',errLogList)
}

export function qiniuUpload(file,key,token){
	return new Promise((resolve)=> {
		const observable = qiniu.upload(file, key, token)
		const observer = {
			error(err) {
				resolve(false)
			},
			complete(res) {
				console.log(res)
				resolve(qiniuUrl + res.key)
			}
		}
		observable.subscribe(observer);
	})
}

export function restLogin(){
	removeStorage('token')
	removeStorage('userinfo')
	removeStorage('user_im_sign')
	removeStorage('en_im_sign')
	store.commit('changeinfo','')
	store.commit('changeToken','')
	store.commit('changeStanding','user')
	store.commit('changeJoinPending',0)
	store.commit('changeDeliverPending',0)
	store.commit('changeInterviewPending',{invite:0,wait:0})
	if (store.state.sdk_ready) Vue.prototype.tim.logout();
}

export function validLogin(rest) {
	if (!getStorage('userinfo') || !getStorage('token') || !getStorage('en_im_sign') || !getStorage('user_im_sign')) {
		if (rest) restLogin();
		return false
	}
	return true
}

export function getIpCity(){
	return new Promise((resolve)=> {
		AMapLoader.load({
			"key": mapKey,
		}).then((AMap) => {
			AMap.plugin('AMap.CitySearch', function () {
				var citySearch = new AMap.CitySearch()
				citySearch.getLocalCity(function (status, result) {
					if (status === 'complete' && result.info === 'OK') {
						resolve(result.city)
					}else{
						resolve()
					}
				})
			})
		}).catch(e => {
			console.log('地图加载出错-----选地址组件',e);
		});
	})
	
}

export function formatCustomTime(timestamp, showTime = false) {
	if(!timestamp) return '';
  const now = new Date();
  const targetDate = new Date(timestamp);

  const timeDifference = now - targetDate;
  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const years = now.getFullYear() - targetDate.getFullYear();

  if (seconds < 60) {
    return '刚刚';
  } else if (now.getDate() === targetDate.getDate() && now.getMonth() === targetDate.getMonth() && now.getFullYear() === targetDate.getFullYear()) {
    // 在今天输出 hh:mm
	const hour = targetDate.getHours().toString().padStart(2,'0')
	const min = targetDate.getMinutes().toString().padStart(2,'0')
    return `${hour}:${min}`;
  } else if (hours<(24+now.getHours()) && now.getMonth() === targetDate.getMonth() && now.getFullYear() === targetDate.getFullYear()) {
	const hour = targetDate.getHours().toString().padStart(2,'0')
	const min = targetDate.getMinutes().toString().padStart(2,'0')
	return `昨日 ${hour}:${min}`;
  } else if (days < 7) {
    // 在一周内输出星期几
	let week = targetDate.getDay()
	switch (week){
		case 1:
			week = '星期一';
			break;
		case 2:
			week = '星期二';
			break;	
		case 3:
			week = '星期三';
			break;	
		case 4:
			week = '星期四';
			break;	
		case 5:
			week = '星期五';
			break;	
		case 6:
			week = '星期六';
			break;
		case 0:
			week = '星期天';
			break;	
	}
    return `${week}`;
  } else if (days < 365||years==0) {
    // 在本年内输出 MM月DD日
    const month = (targetDate.getMonth()+1).toString().padStart(2,'0')
    const day = targetDate.getDate().toString().padStart(2,'0')
    return `${month}月${day}日`;
  } else {
    // 非本年内输出 yyyy年MM月dd日
	const year = targetDate.getFullYear()
	const month = (targetDate.getMonth()+1).toString().padStart(2,'0')
	const day = targetDate.getDate().toString().padStart(2,'0')
	return `${year}年${month}月${day}日`;
  }
}